import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as decode from 'jwt-decode';
import { environment } from './../../../environments/environment';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class AuthService {

  readonly baseUrl = environment.serviceURL;
  
  private profilePic = new BehaviorSubject("");
  currentProfilePic = this.profilePic.asObservable();

  private companyLogo = new BehaviorSubject("");
  currentCompanyLogo = this.companyLogo.asObservable();

  constructor(
    private router: Router,
    private http: HttpClient
  ) {
    this.changeProfilePicture("");
    this.changeCompanyLogo("");
  }

  public isSuperAdmin(): boolean {
    return this.hasRole('SUPER_ADMIN');
  }

  public isAdmin(): boolean {
    return this.hasRole('ADMIN');
  }

  private hasRole(role): boolean {
    const token = localStorage.getItem('token');
    if(token){
        const tokenBody = decode(token);
        return role == tokenBody.role;
    }
    return false;
  }

  public getUserId(): string {
    return this.userProperty('id');
  }

  public getUserRole(): string {
    return this.userProperty('role');
  }

  public getUserName(): string {
    return this.userProperty('name');
  }

  public getProfilePicURL(userId?): string {
    const id = userId?userId:this.userProperty('id');
    let URL = "";
    if(id) {
      URL = this.baseUrl + "/users/"+ id + "/download/profilepic?_dc="+(new Date()).getTime();
    }
    return URL;
  }

  getProfilePicture(userId?) {
    const id = userId?userId:this.userProperty('id');
    return this.http.get<any>("/users/"+ id + "/attachment/profilepic").map(
      resp => {
        let url = '';
        if(resp.success && Array.isArray(resp.data) && resp.data.length > 0) {
          url = resp.data[0].path;
        }
        this.changeProfilePicture(url);
        return resp;
      }
    );
  }

  changeProfilePicture(url: string) {
    if(!url){
      url = this.getProfilePicURL();
    }
    this.profilePic.next(url);
  }

  getCompanyLogo(cId?) {
    const id = cId?cId:this.userProperty('companyId');
    return this.http.get<any>("/companies/"+ id + "/attachment/logo").map(
      resp => {
        let url = '';
        if(resp.success && Array.isArray(resp.data) && resp.data.length > 0) {
          url = resp.data[0].path;
        }
        this.changeCompanyLogo(url);
        return resp;
      }
    );
  }

  changeCompanyLogo(url: string) {
    if(!url){
      url = this.getLogoURL();
    }
    this.companyLogo.next(url);
  }

  public isLoggedInUser(id): boolean {
    return id == this.userProperty('id');
  }

  public getLogoURL(): string {
    const cId = this.userProperty('companyId');
    let URL = "";
    if(cId) {
      URL = this.baseUrl + "/companies/"+ cId + "/download/logo?_dc="+(new Date()).getTime();
    }
    return URL;
  }

  public getCompanyLocation(): any {
    return this.userProperty('companyLocation');
  }

  private userProperty(key): string {
    const token = localStorage.getItem('token');
    if(token){
        const tokenBody = decode(token);
        return tokenBody[key];
    }
    return null;
  }

  public isAuthenticated(): boolean {
    const token = localStorage.getItem('token');
    var flg = false;

    if(token) {
      const helper = new JwtHelperService();
      flg = !helper.isTokenExpired(token)
    }
    // Check whether the token is expired and return
    return token && flg;
  }

  login(user: any){
    if (user.email != '' && user.password != '' ){
      //var data = "username=" + user.userName + "&password=" + user.password;
      //var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/json','No-Auth':'True' });
      return this.http.post('/login', user, { headers: reqHeader });
    }
  }

  checkPassword(user: any){
    if (user.email != '' && user.password != '' ){
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/json','No-Auth':'True' });
      return this.http.post('/login', user, { headers: reqHeader });
    }
  }

  logout(){
      this.http.post('/users/logout', {}, { headers: { 'Content-Type': 'application/json'} }).subscribe((data : any)=>{
        localStorage.removeItem('token');
        this.router.navigate(['/login']);
      });
  }

  forgot(email: string){
    if (email != ''){
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/json','No-Auth':'True' });
      return this.http.post('/forgot-password', {email:email}, { headers: reqHeader });
    }
  }

  reset(data: any){
    if (data.newpassword != '' && data.token != '' ){
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/json','No-Auth':'True' });
      return this.http.post('/reset-password', data, { headers: reqHeader });
    }
  }

  getVehicleTypes(){
      return this.http.get('/vehicle-types');
  }

  getChatUsers(){
      return this.http.get('/messages/listUser');
  }

  getConversations(id){
      return this.http.get('/messages/listMessage', {params:{id:id}});
  }

}



// WEBPACK FOOTER //
// ./src/app/services/auth/auth.service.ts